var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrince2Logo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 241.396,
    height: 47.305,
    viewBox: "0 0 241.396 47.305",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175",
    transform: "translate(-212 -2939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M52.056,6.934H37.433V32.051h4.04V21.825H52.056c6.527,0,9.837-2.509,9.837-7.463,0-4.929-3.31-7.428-9.837-7.428M51.3,18.115H41.473V10.644H51.3c5.569,0,6.689,1.435,6.689,3.752,0,2.3-1.12,3.72-6.689,3.72",
    transform: "translate(234.454 2943.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M79.008,14.2c0-3.313-1.736-7.263-10-7.263H54.583V32.051h4.04V21.43H67.2l7.719,10.621h5.012l-7.985-10.78c3.46-.464,7.062-2.515,7.062-7.073M58.623,17.719V10.643h9.722c4.926,0,6.756.954,6.756,3.521,0,2.59-1.83,3.555-6.756,3.555Z",
    transform: "translate(244.741 2943.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 4.04,
    height: 25.117,
    transform: "translate(327.937 2950.093)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M99.727,25.752,82.7,6.933H77.758V32.052h3.907V11.561l18.376,20.491h3.726V6.933h-4.04Z",
    transform: "translate(258.642 2943.159)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M120.256,23.817c-1.917,3.545-5.123,5.342-9.529,5.342-6.521,0-10.417-3.376-10.417-9.033,0-6.439,3.6-9.986,10.151-9.986,3.3,0,7.623.91,9.473,5.231l.229.536,3.548-1.635-.224-.509c-1.982-4.51-6.862-7.2-13.058-7.2-8.772,0-14.224,5.057-14.224,13.2,0,8.081,5.463,13.1,14.256,13.1,6.47,0,10.847-2.376,13.373-7.27l.266-.515-3.584-1.745Z",
    transform: "translate(269.708 2942.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M119.582,20.869H135.02v-3.71H119.582V10.642h18.473V6.933H115.542V32.051H138.45V28.339H119.582Z",
    transform: "translate(281.306 2943.159)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M145.907,23.025l.182-.08c3.888-1.7,7.91-3.448,7.91-8.79,0-4.825-3.836-7.594-10.529-7.594-8.286,0-10.615,5.654-11,6.787l-.163.48,3.356,1.584.237-.526c.993-2.208,2.792-4.745,7.894-4.745,3.763,0,6.291,1.667,6.291,4.15,0,2.958-2.069,3.894-5.827,5.593-.986.446-2.067.934-3.224,1.517-6.425,3.193-8.21,6.689-8.8,7.838l-.062.123v2.913H154V28.7H136.9c2.384-2.76,5.217-4.006,9.005-5.671",
    transform: "translate(291.286 2942.936)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M150.2,6.946a2.775,2.775,0,1,0,2.819,2.766A2.792,2.792,0,0,0,150.2,6.946m0,4.977a2.155,2.155,0,0,1-2.16-2.211,2.137,2.137,0,1,1,4.27.018,2.12,2.12,0,0,1-2.11,2.193",
    transform: "translate(300.376 2943.167)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M150.163,9.29V9.257a.716.716,0,0,0,.573-.659.7.7,0,0,0-.286-.59,1.478,1.478,0,0,0-.945-.219,7.531,7.531,0,0,0-1.064.085v2.768h.642v-1.1h.3c.355,0,.523.134.574.422a2.155,2.155,0,0,0,.219.675h.675a2.446,2.446,0,0,1-.2-.675c-.085-.373-.219-.59-.49-.675m-.76-.2h-.3V8.3a1.486,1.486,0,0,1,.355-.035c.4,0,.589.17.589.422,0,.288-.286.4-.64.4",
    transform: "translate(301.04 2943.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M49.284,30.2c.232-1.645.45-3.387.544-5.191a25.019,25.019,0,0,0-48-9.892.5.5,0,0,1-.029.067c-.1.24-.2.478-.288.72-.074.189-.142.378-.21.566-.035.1-.069.194-.1.291-.09.264-.176.53-.256.8L.9,17.736c-.077.267-.15.533-.219.8-.037.146-.07.293-.1.438-.037.162-.075.322-.109.483-.018.083-.038.163-.056.245l.022-.061A22.39,22.39,0,0,0,1.512,32.1a.577.577,0,0,1-.035-.062c.054.139.114.275.171.413s.1.248.152.371c.042.1.086.194.131.29A22.427,22.427,0,0,0,4.068,36.9l.059.083c.144.2.288.4.438.6a24.119,24.119,0,0,0,37.582,1.39c1.853,4.4,5.713,8.143,13.714,7.332-1.08-.354-9.076-.29-6.577-16.11M27.135,40.748a7.091,7.091,0,0,1-5.441.544,18.321,18.321,0,0,1,.654-35.164,8.816,8.816,0,0,1,6.452.717l.03.016c-.133.006-.262,0-.4.014A17.115,17.115,0,0,0,13.213,19.11c.016-.04.035-.078.051-.12-.085.227-.166.454-.24.688-2.665,8.338,2.637,16.981,11.308,20.281a15.507,15.507,0,0,0,2.83.774Zm8.794-8.481a24.7,24.7,0,0,1-4.392,5.35,2.884,2.884,0,0,1-3.02.544c-7.623-3.068-10.3-9.234-8.134-16.006a13.293,13.293,0,0,1,6.763-8.03,7.988,7.988,0,0,1,11.439,6.219,19.08,19.08,0,0,1-2.656,11.924",
    transform: "translate(212 2939)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrince2Logo);
export default __webpack_public_path__ + "static/media/prince2-logo.d2512ee4.svg";
export { ForwardRef as ReactComponent };